// Custom PrimeNG type definitions to replace imports that are not compatible with Angular v20
// These interfaces match the PrimeNG API but are defined locally to avoid import issues

export interface SelectItem {
    label?: string;
    value?: any;
    disabled?: boolean;
    icon?: string;
    title?: string;
    styleClass?: string;
    style?: { [klass: string]: any } | null | undefined;
}

export interface MenuItem {
    label?: string;
    icon?: string;
    title?: string;
    url?: string;
    routerLink?: any;
    queryParams?: { [k: string]: any };
    fragment?: string;
    queryParamsHandling?: any;
    preserveFragment?: boolean;
    skipLocationChange?: boolean;
    replaceUrl?: boolean;
    state?: { [k: string]: any };
    items?: MenuItem[];
    expanded?: boolean;
    disabled?: boolean;
    visible?: boolean;
    target?: string;
    escape?: boolean;
    routerLinkActiveOptions?: any;
    separator?: boolean;
    badge?: string;
    tooltip?: string;
    tooltipPosition?: string;
    badgeStyleClass?: string;
    style?: { [klass: string]: any } | null | undefined;
    styleClass?: string;
    id?: string;
    automationId?: any;
    tabindex?: string;
    iconStyle?: { [klass: string]: any } | null | undefined;
    iconClass?: string;
    tooltipOptions?: any;
    command?(event: MenuItemCommandEvent): void;
    [key: string]: any;
}

export interface MenuItemCommandEvent {
    originalEvent?: Event;
    item?: MenuItem;
    index?: number;
}

export interface Message {
    severity?: 'success' | 'info' | 'warn' | 'error';
    summary?: string;
    detail?: string;
    id?: string;
    key?: string;
    life?: number;
    sticky?: boolean;
    closable?: boolean;
    data?: any;
}

export interface FilterMetadata {
    value?: any;
    matchMode?: string;
    operator?: string;
    [key: string]: any;
}

export type FilterMatchMode = 'startsWith' | 'contains' | 'notContains' | 'endsWith' | 'equals' | 'notEquals' | 'in' | 'lt' | 'lte' | 'gt' | 'gte' | 'between' | 'dateIs' | 'dateIsNot' | 'dateBefore' | 'dateAfter';
